// / content-types
export const URL_CONTENT_TYPE_FORM = 'application/x-www-form-urlencoded'
export const URL_CONTENT_TYPE_JSON = 'application/json;charset=UTF-8'
export const URL_CONTENT_TYPE_MULTIPART = 'multipart/form-data'

// 生产接口
export const URL_DOMAIN = 'https://inlet.livemusichina.com' // -- 接口地址



// WEBPACK FOOTER //
// ./src/network/consts.js